// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class DoubleMatrix {
    constructor(length) {
        this.Length = length;
        this.FArray = new Array(length);
    }
    // #region this[int index]
    get(index) {
        return this.FArray[index];
    }
    set(index, value) {
        this.FArray[index] = value;
    }
    // #endregion this[int index]
    Resize(new_size) {
        const newArray = new Array[new_size]();
        for (let i = 0; i < Math.min(new_size, this.FArray.length); i++) {
            newArray[i] = this.FArray[i];
        }
        this.FArray = newArray;
        this.Length = this.FArray.length;
    }
    Dispose() {
        if (this.FArray != null) {
            for (let i = 0; i < this.FArray.length; i++) {
                if (this.FArray[i].Dispose) {
                    this.FArray[i].Dispose();
                }
            }
            this.FArray = null;
        }
    }
    Clear() {
        for (let i = 0, len = this.FArray.length; i < len; i++) {
            this.FArray[i].Clear();
        }
    }
}
/// ///////////////////////////////////////////////////////////////////////////////////////////
export class DoubleVector {
    constructor(length) {
        this.FArray = new Array(length);
        this.Length = length;
    }
    // #region this[int index]
    get(index) {
        return this.FArray[index];
    }
    set(index, value) {
        this.FArray[index] = value;
    }
    // #endregion this[int index]
    Dispose() {
        this.FArray = null;
    }
    Clear() {
        for (let i = 0, len = this.FArray.length; i < len; i++) {
            this.FArray[i].Clear();
        }
    }
}
/// ///////////////////////////////////////////////////////////////////////////////////////////
/// <summary>
/// Расширяемый массив даблов (на базе arraylist)
/// </summary>
export class ExpandDoubleVector {
    constructor(counts, shift) {
        this.FList = new Array(counts || 0);
        this.FShift = shift || 0;
    }
    Add(value) {
        this.FList.push(value);
    }
    Clear() {
        this.FList.length = 0;
    }
    // #region this[int index]
    get(index) {
        index -= this.FShift;
        return index >= 0 && index < this.FList.length ? this.FList[index] : 0.0;
    }
    set(index, value) {
        if (index >= 0 && index < this.FList.length) {
            this.FList[index] = value;
        }
    }
    // #endregion this[int index]
    get Length() {
        return this.FList.length;
    }
    set Length(value) {
        this.FList.length = 0;
        this.FList = this.FList.concat(new Array(value));
    }
    // Смещение вдоль вектора
    get Shift() {
        return this.FShift;
    }
    set Shift(value) {
        this.FShift = value;
    }
    Dispose() {
        if (this.FList != null) {
            this.FList.length = 0;
        }
    }
}
